
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import {
  getPropertiesEditableInComponent,
  isControlPathAnEditableProperty
} from "@/lib/components/editable-properties";
import { isControlAllowedAsEditablePropertyInComponent } from "@/lib/components/util";
import { toggleEditablePropertyForControlPath } from "@/lib/components/editable-properties";
import { isOpenDocumentAComponent } from "@/lib/components/util";
import ComponentEditablePropertySettings from "@/components/Reusable/ControlsTree/ComponentEditablePropertySettings.vue";
import { configStore, documentStore, uiStore } from "@/store/store";
import { PropertyEditableInComponent } from "@/types/components";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { isNodeADescendantOf } from "@/lib/tree/nesting";

@Component({
  components: {
    Icon,
    ComponentEditablePropertySettings,
    Dropdown
  }
})
export default class ComponentEditablePropertyToggle extends Vue {
  @Prop()
  path!: string;

  get shouldShow() {
    return (
      this.isEditingComponent &&
      this.isControlAllowedAsEditablePropertyInComponent
    );
  }

  get isControlAllowedAsEditablePropertyInComponent() {
    return isControlAllowedAsEditablePropertyInComponent(this.path);
  }

  get isEditingComponent() {
    if (
      this.builderMode === "oxygen" &&
      uiStore.inlineEditingElement &&
      uiStore.activeElement
    ) {
      return isNodeADescendantOf(
        documentStore.document.tree,
        uiStore.activeElement,
        uiStore.inlineEditingElement
      );
    }

    return isOpenDocumentAComponent();
  }

  get enabled() {
    return isControlPathAnEditableProperty(this.path);
  }

  toggle() {
    toggleEditablePropertyForControlPath(this.path);
  }

  get propertyEditableInComponent(): false | PropertyEditableInComponent {
    if (!uiStore.activeElement) return false;

    const editablePropertyInComponent = getPropertiesEditableInComponent(
      uiStore.activeElement
    ).find(editableProperty => {
      return editableProperty.controlPath === this.path;
    });

    return editablePropertyInComponent ?? false;
  }

  get classes() {
    return {
      "component-editable-property-toggle-button": true,
      "breakdance-control-modifier-icon": true,
      "breakdance-control-modifier-icon-enabled": this.enabled,
      "breakdance-control-modifier-icon-value-present": this.enabled
    };
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
